import { HoursDaysWeeks } from "@/interfaces/dates.interface";
import { PriceItemInterface } from "@/interfaces/prices.interface";
import { findMaxHours } from "./prices.utils";

export const getDefaultParkingRange = (): [Date, Date] => {
    const entryDate = getCurrentDateTime();
    const exitDate = new Date(entryDate);

    return [entryDate, exitDate];
};

const roundTimeToNextHalfHour = (date: Date) => {
    // Get minutes and seconds
    const minutes = date.getMinutes();

    // If minutes is less than 30, round up to 30
    if (minutes < 30) {
        date.setMinutes(30);
        date.setSeconds(0);
    }
    // If minutes is greater than or equal to 30, round up to the next hour
    else {
        date.setHours(date.getHours() + 1);
        date.setMinutes(0);
        date.setSeconds(0);
    }
};

export const getCurrentDateTime = () => {
    const now = new Date();

    roundTimeToNextHalfHour(now);

    now.setMilliseconds(0);
    now.setSeconds(0);
    return now;
};

export const getCurrentDateTimeString = () => {
    const now = getCurrentDateTime();
    return now.toISOString().slice(0, -1);
};

/**
 * Calculates the hours, days and weeks of a given amount of seconds
 * @param seconds Number of seconds to evaluate
 * @returns [hours, days, weeks]
 */
export function secondsToHoursDaysWeeks(seconds: number): HoursDaysWeeks;
/**
 * Calculates the hours, days and weeks of a given amount of seconds
 * @param seconds Number of seconds to evaluate
 * @param priceList if the prices should be taken into account for the time calculation
 * @returns [hours, days, weeks] - rounded to fit to the price list
 */
export function secondsToHoursDaysWeeks(seconds: number, priceList: PriceItemInterface[]): HoursDaysWeeks;
export function secondsToHoursDaysWeeks(seconds: number, priceList?: PriceItemInterface[]): HoursDaysWeeks {
    //convert back to weeks, days, and hours
    const weeks = Math.floor(seconds / 604800);
    const secondsForDays = seconds % 604800;
    const days = Math.floor(secondsForDays / 86400);
    const secondsForHours = secondsForDays % 86400;
    const hours = Math.floor(secondsForHours / 3600);

    if (priceList) {
        const maxHours = findMaxHours(priceList);
        if (hours > maxHours || (hours && (days || weeks))) {
            const updatedDays = days + 1;

            if (updatedDays === 7) {
                return [0, 0, weeks + 1];
            }

            return [0, days + 1, weeks];
        }
    }

    return [hours, days, weeks];
}

export const getDateOneYearFromDate = (date: Date) => {
    const dateInOneYear = date;
    dateInOneYear.setDate(dateInOneYear.getDate() + 365);
    return dateInOneYear;
};
